import { Show, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { StructuredData } from './structured-data';

type BreadcrumbItem = {
    name: string;
    url: string;
};

type BreadcrumbSchemaProps = {
    items: BreadcrumbItem[];
};

/**
 * BreadcrumbList schema for navigation hierarchy.
 * Enables Google to show breadcrumb navigation in search results.
 *
 * @see https://schema.org/BreadcrumbList
 * @see https://developers.google.com/search/docs/appearance/structured-data/breadcrumb
 */
export const BreadcrumbSchema = (props: BreadcrumbSchemaProps) => {
    const { siteInfo } = useContext(AppContext);
    const baseUrl = `https://${siteInfo.currentDomain}`;

    const schema = () => ({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: props.items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: item.url.startsWith('http') ? item.url : `${baseUrl}${item.url.startsWith('/') ? '' : '/'}${item.url}`,
        })),
    });

    return (
        <Show when={props.items?.length > 0}>
            <StructuredData data={schema()} />
        </Show>
    );
};
